export const ADMIN_REQUEST = 'ADMIN_REQUEST';
export const ADMIN_SUCCESS = 'ADMIN_SUCCESS';
export const ADMIN_ERROR = 'ADMIN_ERROR';
export const ADMIN_REGISTER = 'ADMIN_REGISTER';
export const ADMIN_REGISTER_SUCCESS = 'ADMIN_REGISTER_SUCCESS';
export const ADMIN_REGISTER_ERROR = 'ADMIN_REGISTER_ERROR';

export const ADMIN_VALIDATE = 'ADMIN_VALIDATE';
export const ADMIN_VALIDATE_SUCCESS = 'ADMIN_VALIDATE_SUCCESS';
export const ADMIN_VALIDATE_ERROR = 'ADMIN_VALIDATE_ERROR';

export const ADMIN_PROFILE_UPDATE = 'ADMIN_PROFILE_UPDATE';
export const ADMIN_PROFILE_UPDATE_SUCCESS = 'ADMIN_PROFILE_UPDATE_SUCCESS';
export const ADMIN_PROFILE_UPDATE_ERROR = 'ADMIN_PROFILE_UPDATE_ERROR';
